<template>
  <div class="fly">
    <div class="flyContent">
      <dv-flyline-chart-enhanced :config="config" style="width:100%;height:100%;" />
    </div>
  
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data(){
  return{
    config:{
      points: [
    {
      name: 'Suqian',
      coordinate: [0.35, 0.52],
      icon: {
        src: require('../static/img/add2.png'),
        width: 30,
        height: 60,
        
      },
      // halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:70
      // },
      text: {
        color: '#666'
      }
    },

    {
      name: 'SouthKorea',
      coordinate: [0.387, 0.449]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    {
      name: 'Japan',
      coordinate: [0.425, 0.415]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    {
      name: 'Malaysia',
      coordinate: [0.32, 0.67]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    {
      name: 'Mauritius',
      coordinate: [0.233, 0.755]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    
    {
      name: 'Cameroon',
      coordinate: [0.07, 0.655]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    {
      name: 'Australia',
      icon:{
        src: require('../static/img/point1.png'),
      },
      coordinate: [0.405, 0.825]
      // ,halo: {
      //   show: true,
      //   color:'#979797',
      //   radius:40
      // },
    },
    {
      name: 'Canada',
      coordinate: [0.724, 0.232],
      icon:{
        src: require('../static/img/point1.png'),
      },
      // halo: {
      //   show: true,
      //   color:'#979797',
      //   radius:40
      // },
    },
    {
      name: 'United States of America',
      coordinate: [0.798, 0.38]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    {
      name: 'Mexico',
      coordinate: [0.76, 0.505],
      icon:{
        src: require('../static/img/point1.png'),
      },
      // halo: {
      //   show: true,
      //   color:'#979797',
      //   radius:40
      // },
    },
    {
      name: 'Guatemala',
      coordinate: [0.795, 0.545]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    {
      name: 'Panama',
      coordinate: [0.808, 0.583]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    {
      name: 'Peru',
      coordinate: [0.832, 0.715]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    {
      name: 'Chile',
      coordinate: [0.845, 0.835]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
    {
      name: 'Brazil',
      coordinate: [0.89, 0.705]
      // ,halo: {
      //   show: true,
      //   color:'#ff9a38',
      //   radius:40
      // },
    },
   
  ],
  lines: [ 
     {
      target: 'SouthKorea',
      source: 'Suqian'
    },
    {
      target: 'Japan',
      source: 'Suqian'
    },
    {
      target: 'Malaysia',
      source: 'Suqian'
    },
    {
      target: 'Mauritius',
      source: 'Suqian'
    },
    {
      target: 'Cameroon',
      source: 'Suqian'
    },
    {
      target: 'Australia',
      source: 'Suqian'
    },
    {
      target: 'Canada',
      source: 'Suqian'
    },
    {
      target: 'United States of America',
      source: 'Suqian'
    },
    {
      target: 'Mexico',
      source: 'Suqian'
    },
    {
      target: 'Guatemala',
      source: 'Suqian'
    },
    {
      target: 'Panama',
      source: 'Suqian'
    },
    {
      target: 'Peru',
      source: 'Suqian'
    },
    {
      target: 'Chile',
      source: 'Suqian'
    },
    {
      target: 'Brazil',
      source: 'Suqian'
    },
  ],
  
  icon: {
    show: true,
    src: require('../static/img/point.png'),
    width:15,
    height:15
  },
  text: {
    show: true,
    color:"#696969",
    fontSize:13
  },
  line:{
    color: '#0265b5',
    width:3,
    orbitColor:"#0137620d",
    duration:[25,25]
  },
  bgImgSrc:require('../static/img/map.png'),
    }
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.fly{
  width: 99vw;
  height: 40vw;
  margin: 0 auto;
}
.flyContent{
width: 100%;
height: 100%;
}
@media screen and (max-width: 900px) {
  .fly{
  width: 95vw;
  height: 65vw;
  margin: 0 auto;
  
}
.fly .dv-flyline-chart-enhanced text{
  font-size: 18px !important;
}
}
</style>
